module.exports = __webpack_public_path__ + "img/mc_hrz_pos.9a5d5c40.svg";